export default "__VITE_ASSET__Dkn_8LNM__"